<!-- BANNER -->
<div class="mobile-header">
  <a class="back-btn text-white" [routerLink]="['/']">
    <i class="material-icons">arrow_back_ios</i>
  </a>
  <h5 class="title">{{ 'terms.page.title' | translate }}</h5>
</div>
<div class="container">
  <!--Terms-->
  <div class="row">
    <div class="col-12">
      <div class="card bg-secondary">
        <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate">
        </fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">{{ 'default.terms.text' | translate }}</p>
</ng-template>
